import { render } from "./PrivacyPolicyForm.vue?vue&type=template&id=be06b482&lang=true"
import script from "./PrivacyPolicyForm.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__